import styled from "styled-components";

export const FirstContainer = styled.div`
  width: 92%;
  position: relative;
  left: 0;
  right: 0;
  margin: auto;
`;

export const Container = styled.div`
  margin-top: 9px;
  box-sizing: border-box;

  position: relative;

  & div {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    & img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    & a {
      height: 24px;
    }

    & h1 {
      position: relative;
      left: -12px;
      align-self: center;

      font-weight: 700;
      font-size: 1.125rem;
      text-align: center;
      letter-spacing: -0.02em;
      margin: 9px auto;
    }
  }
`;

export const DetailComments = styled.div`
  /* display: relative; */
  padding-bottom: 68px;

  & .commentsMargin {
    position: fixed;
    width: 92%;
    height: 15px;
    bottom: 57.5px;
    background-color: #fff;

    & .inputComments {
      position: fixed;
      bottom: 57.5px;
      width: 92%;

      margin: 10px 0;

      padding-left: 12px;
      padding-right: 12px;
      background: #f1f3f5;
      border-radius: 8px;
      box-sizing: border-box;

      & textarea {
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        overflow: hidden;

        font-size: 14px;

        background: #f1f3f5;
        box-sizing: border-box;

        &::placeholder {
          font-size: 14px;
          letter-spacing: -0.02em;
          color: #4a5056;
        }

        &.blur {
          margin-top: 12px;
          margin-bottom: 8px;
        }

        &.focus {
          margin-top: 12px;
          margin-bottom: 8px;
          color: #4a5056;
          caret-color: #ff7a00;

          &::placeholder {
            color: #878e95;
          }
        }
      }

      & .textareaAside {
        display: flex;
        justify-content: space-between;
        padding-bottom: 8px;
        margin-top: 14px;
        color: #4a5056;
        box-sizing: border-box;

        & div {
          font-size: 12px;
        }

        & button {
          border: none;
          outline: none;
          font-size: 14px;
          cursor: pointer;

          &.orange {
            color: #ff7a00;
            font-weight: 700;
            cursor: pointer;
          }
          &.black {
            color: #000;
            font-weight: 400;
          }
        }
      }
    }
  }
`;

export const InputRecomments = styled.div``;
